export default __webpack_public_path__ + "static/media/ΕΛΙΝ_ΗΛ.5769047a.png";